import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getCardsConfigs() {
    return {
        custom: {
            [PALETTE_IDS.EVENT_CARDS]: {
                MatchEventCard: {
                    gameLineMarketContent: {
                        participants: {
                            showTeamLogo: true,
                            showShortName: true,
                        },
                    },
                    eventItemDetails: {
                        participants: {
                            showTeamLogo: true,
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.EVENT_CARDS]: {
                CARD_BASE_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_EVENT_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_SPORT_ICON_COLOR: COLOR.BRAND.FOREGROUND1,

                CARD_MARKET_NAME_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_RACE_INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                CARD_WATERMARK_ICON_COLOR: COLOR.RESERVED.WHITE,
                CARD_PARTICIPANTS: {
                    PITCHER_TEXT: {
                        fontWeight: FONT.WEIGHT_MEDIUM,
                        color: COLOR.BRAND.FOREGROUND2,
                    },
                    PARTICIPANTS_TEXT: {
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    },
                },

                CARD_SELECTION_MARKET_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                CARD_SELECTION_PRICE_BOOST_CONTAINER_BG: COLOR.BRAND.BACKGROUND4,
                CARD_MATCH_ACCA_BB_BET_ICON_COLOR: COLOR.BRAND.ACCENT1,
                CARD_MATCH_ACCA_EVENT_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                CARD_GAMELINE_MARKET_HEADER_TEXT: {
                    fontWeight: FONT.WEIGHT_MEDIUM,
                },
                CARD_PREBUILT_ACCA_SELECTION_BB_BET_MARKET_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
        },
    };
}
